import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private swUpdate = inject(SwUpdate);
  private snackBar = inject(MatSnackBar);

  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => this.promptForUpdate());

    void this.swUpdate.checkForUpdate().catch(() => undefined);
  }

  private promptForUpdate(): void {
    const ref = this.snackBar.open('A new version is available.', 'Reload', {
      duration: undefined,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['toast-warn'],
    });

    ref.onAction().subscribe(() => {
      void this.activateAndReload();
    });
  }

  private async activateAndReload(): Promise<void> {
    try {
      await this.swUpdate.activateUpdate();
    } finally {
      document.location.reload();
    }
  }
}
